import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import PostBox1 from '../helpers/PostBox1';
import GlobalSearch from '../components/GlobalSearch';

const HashtagPage = () => {
    const { tag } = useParams();
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [singlePost, setSinglePost] = useState(null);

    const fetchPosts = useCallback(async (pageNum = 1) => {
        setLoading(true);
        try {
            const res = await axios.get('https://buzzinguniverse.com/backend/api/hashtag/posts', {
                params: { tag, page: pageNum, visitor_id: auth?.id },
            });
            if (res.data.code === 200) {
                if (pageNum === 1) {
                    setPosts(res.data.data);
                } else {
                    setPosts(prev => [...prev, ...res.data.data]);
                }
                setTotal(res.data.total || 0);
            } else {
                if (pageNum === 1) setPosts([]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [tag, auth?.id]);

    useEffect(() => {
        setPage(1);
        setPosts([]);
        fetchPosts(1);
    }, [tag]);

    const loadMore = () => {
        const next = page + 1;
        setPage(next);
        fetchPosts(next);
    };

    return (
        <section>
            <GlobalSearch />
            <div className="personal_right_box py-5">
                <div className="container">
                    <div className="row" style={{ justifyContent: 'center' }}>
                        <div className="col-md-9">
                            <div className="tab-new" style={{ marginRight: '-12%', marginLeft: '12%' }}>

                                {/* Header */}
                                <div className="hashtag-page-header">
                                    <div className="hashtag-page-icon">#</div>
                                    <div>
                                        <h2 className="hashtag-page-title">#{tag}</h2>
                                        {!loading && (
                                            <p className="hashtag-page-count">
                                                {total} {total === 1 ? 'post' : 'posts'}
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="personal_des_box_main">
                                    {/* Posts */}
                                    {posts.map((post, i) => (
                                        <PostBox1
                                            key={post.post_data?.id || i}
                                            post={post}
                                            usrAuth={auth}
                                            setSinlgePost={setSinglePost}
                                            inGroup={false}
                                            groupAdmins={[]}
                                        />
                                    ))}

                                    {/* Loading */}
                                    {loading && (
                                        <div className="hashtag-page-loading">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    )}

                                    {/* Empty */}
                                    {!loading && posts.length === 0 && (
                                        <div className="sorry-activity-found activity-all-memeber">
                                            <ul>
                                                <li><i className="fas fa-info" /></li>
                                                <li><p>No posts found for <strong>#{tag}</strong></p></li>
                                            </ul>
                                        </div>
                                    )}

                                    {/* Load more */}
                                    {!loading && posts.length > 0 && posts.length < total && (
                                        <div style={{ textAlign: 'center', marginTop: 20 }}>
                                            <button className="btn btn-outline-primary" onClick={loadMore}>
                                                Load more
                                            </button>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HashtagPage;
